import React from "react";
import classNames from "classnames";

import * as c from "./lpCompetitorReviewBadges.module.scss";
import ReviewBadges from "@components/shared/reviewBadges";

const LpCompetitorReviewBadges = () => {
  return (
    <div className={c.container}>
      <h3 className={classNames(c.heading, "h3")}>Don't just take our word for it</h3>
      <p className={classNames(c.subheading, "p3")}>Hear from real Mangomint customers why they made the switch</p>
      <ReviewBadges />
    </div>
  );
};

export default LpCompetitorReviewBadges;
